/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { JoinEntityDto } from './join-entity-dto';
import { UrlInfoDto } from './url-info-dto';
 /**
 *
 *
 * @export
 * @interface ExerciseSourceDto
 */
export interface ExerciseSourceDto {

    /**
     * Unique identifier
     *
     * @type {number}
     * @memberof ExerciseSourceDto
     * @example 1
     */
    id: number;

    /**
     * Creation timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     * @example 2024-01-15T10:30:00.000Z
     */
    created: string;

    /**
     * Last update timestamp (ISO 8601)
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     * @example 2024-06-01T08:00:00.000Z
     */
    updated: string;

    /**
     * Soft-delete timestamp — null when the record is active
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    deleted: string | null;

    /**
     * Object name in storage, content-addressed for uploaded files. An address, not a display label, and not editable — use originalName.
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    name: string;

    /**
     * File name as uploaded, for display. Null on reads that do not resolve the stored file (sessions, station).
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    originalName: string | null;

    /**
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    os: ExerciseSourceDtoOsEnum;

    /**
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    type: ExerciseSourceDtoTypeEnum;

    /**
     * Unity CRC of the bundle, as text (uint32); null when unknown
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    crc: string | null;

    /**
     * AssetFileHash of the bundle; null when unknown
     *
     * @type {string}
     * @memberof ExerciseSourceDto
     */
    hash: string | null;

    /**
     * @type {UrlInfoDto}
     * @memberof ExerciseSourceDto
     */
    url: UrlInfoDto;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseSourceDto
     */
    exercise: JoinEntityDto;

    /**
     * @type {JoinEntityDto}
     * @memberof ExerciseSourceDto
     */
    client: JoinEntityDto;
}

/**
 * @export
 * @enum {string}
 */
export enum ExerciseSourceDtoOsEnum {
    IOS = 'IOS',
    ANDROID = 'ANDROID',
    WEB = 'WEB',
    MACOS = 'MACOS',
    LINUX = 'LINUX',
    WINDOWS = 'WINDOWS',
    ALL = 'ALL'
}
/**
 * @export
 * @enum {string}
 */
export enum ExerciseSourceDtoTypeEnum {
    BUNDLE = 'BUNDLE',
    THUMBNAIL = 'THUMBNAIL',
    ICON = 'ICON',
    COVER = 'COVER',
    VIDEO = 'VIDEO'
}

